<div class="flex flex-col gap-6 w-full text-pet-color-text-1 font-bold items-center">

  <!-- Carousel Container con Botones a los Lados -->
  <div class="flex items-center justify-center gap-4 w-full min-w-0">
    
    <!-- Botón Anterior (Izquierda) -->
    <button (click)="prevCard()"
            class="flex-shrink-0 p-1 text-pet-color-blue-4 hover:opacity-60 transition-opacity">
      <mat-icon class="text-lg">chevron_left</mat-icon>
    </button>

    <!-- CONTENEDOR DE LA TARJETA -->
    <div class="w-full max-w-[320px] md:max-w-[400px] min-w-0 flex flex-col gap-3 items-center justify-center overflow-hidden">
      
      <!-- Imagen: Contenedor con altura fija y ancho 100% -->
      <div class="w-full flex justify-center items-center h-28 md:h-36 p-2 bg-transparent">
        <img class="object-contain w-full h-full animate-slide-in" 
             [src]="cards[currentIndex].image" 
             [alt]="cards[currentIndex].alt">
      </div>

      <!-- Texto: Ancho 100% del contenedor fijo, con un alto mínimo para evitar saltos -->
      <div class="text-center text-sm md:text-base animate-slide-in w-full px-2 min-h-[48px] flex items-center justify-center">
        {{ cards[currentIndex].text }}
      </div>

    </div>

    <!-- Botón Siguiente (Derecha) -->
    <button (click)="nextCard()"
            class="flex-shrink-0 p-1 text-pet-color-blue-4 hover:opacity-60 transition-opacity">
      <mat-icon class="text-lg">chevron_right</mat-icon>
    </button>

  </div>

  <!-- Indicadores de Posición (Debajo) -->
  <div class="flex gap-2 justify-center items-center">
    <span *ngFor="let card of cards; let i = index"
          [class.bg-pet-color-blue-4]="i === currentIndex"
          [class.bg-gray-300]="i !== currentIndex"
          class="w-2 h-2 rounded-full cursor-pointer transition-all hover:scale-125"
          (click)="goToCard(i)"
          [attr.aria-label]="'Ir a tarjeta ' + (i + 1)">
    </span>
  </div>

  <!-- Botón Suscribirse (Deshabilitado) -->
  <div class="flex w-full justify-center md:justify-end">
    <button disabled 
            class="bg-gray-400 text-white font-bold py-2 px-5 rounded-full flex items-center gap-2 md:mr-12 cursor-not-allowed opacity-60">
      ¡Proximamente!
    </button>
  </div>

</div>